import { render } from "./NavHeader.vue?vue&type=template&id=49febede&scoped=true&ts=true"
import script from "./NavHeader.vue?vue&type=script&lang=ts"
export * from "./NavHeader.vue?vue&type=script&lang=ts"

import "./NavHeader.vue?vue&type=style&index=0&id=49febede&lang=less&scoped=true"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49febede"]])

export default __exports__